<template>
  <details-form :isCreate="isCreate" :isEdit="isEdit" :isDuplicate="$route.params.isDuplicate" :extra="extra" :place="place" />
</template>
<script>
import { useExtraStore } from '@/stores'
import { mapState } from 'pinia'
import DetailsForm from './DetailsForm.vue'
import { clone } from 'ramda'

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clone,
  },
  computed: {
    ...mapState(useExtraStore, {
      extraFindById: 'findById',
    }),
    extra () {
      // If duplicate, create a copy of selected extra and remove values added by BEAM
      if (this.extraFindById(this.$route.params.extraId) && this.$route.params.isDuplicate) {
        const duplicateExtra = this.clone(this.extraFindById(this.$route.params.extraId))

        duplicateExtra.prevId = duplicateExtra.id

        delete duplicateExtra.id
        delete duplicateExtra['@id']
        delete duplicateExtra.units

        return duplicateExtra
      }

      return (
        this.extraFindById(this.$route.params.extraId) || {
          place: this.place['@id'],
          name: '',
          description: '',
          type: 'DOG',
          priceType: 1,
          priceValue: 0,
          chargeType: 1,
          durationType: 1,
          max: 1,
          units: [],
        }
      )
    },
    isCreate () {
      return !this.isEdit
    },
    isEdit () {
      return 'id' in this.extra
    },
  },
  components: { DetailsForm },
}
</script>
